module.exports = new __parcel__URL__("leaderboard_xp_button.cb1852e6.png").toString();